module.exports = __webpack_public_path__ + "img/red-tee.67442717.jpg";